import { useMe, useProjectArchivedAt, useSetProjectArchived } from "../api.ts";
import { Action } from "../calm.tsx";
import { ErrorNote } from "../ui.tsx";

/** Shown on an archived project's pages. */
export function ArchivedBanner({ projectId, archivedAt, isAdmin }: { projectId: string; archivedAt: number; isAdmin: boolean }) {
  const unarchive = useSetProjectArchived();
  return (
    <div role="status" data-testid="archived-banner" className="mt-6 flex flex-wrap items-center justify-between gap-3 rounded-2xl bg-ink/[0.05] px-5 py-3 text-[13.5px] text-ink-2">
      <span>
        <span className="font-medium text-ink">Archived</span> · since {new Date(archivedAt).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" })}. No new work starts here; everything is kept.
      </span>
      <ErrorNote error={unarchive.error} />
      {isAdmin && (
        <Action disabled={unarchive.isPending} testId="unarchive-project" onClick={() => unarchive.mutate({ id: projectId, archived: false })}>
          Unarchive
        </Action>
      )}
    </div>
  );
}

/** The banner for any page that belongs to a project (project, lessons, intent, task); renders nothing while the project is active. */
export function ProjectArchivedNotice({ projectId }: { projectId: string }) {
  const archivedAt = useProjectArchivedAt(projectId);
  const isAdmin = useMe().data?.access === "admin";
  return archivedAt === null ? null : <ArchivedBanner projectId={projectId} archivedAt={archivedAt} isAdmin={isAdmin} />;
}
